import Layout from "@/components/layout/Layout";
import CustomSectionsRenderer from "@/components/CustomSectionsRenderer";
import { useTheme } from "@/contexts/ThemeContext";
import { getSectionComponent } from "@/components/themes/sectionRegistry";
import { useMemo } from "react";

const Index = () => {
  const { themeState, getPublishedSections } = useTheme();
  const sections = useMemo(() => getPublishedSections(), [getPublishedSections]);
  const businessType = themeState.published.businessType;

  return (
    <Layout>
      {sections
        .filter((s) => s.visible)
        .map((section) => {
          const Component = getSectionComponent(businessType, section.id);
          return Component ? <Component key={section.id} /> : null;
        })}
      <CustomSectionsRenderer pageId="home" />
    </Layout>
  );
};

export default Index;
